export default function InfoCircle({ width, height, fillColour, className, style }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      width={width}
      height={height}
      className={className}
      style={style}
    >
      <path fill={fillColour} d="M7.37 6.7h1.25v5H7.37z"></path>
      <circle cx="8" cy="4.85" r=".65" fill={fillColour}></circle>
      <path
        fill={fillColour}
        d="M8 .5A7.77 7.77 0 0 0 0 8a7.77 7.77 0 0 0 8 7.5A7.77 7.77 0 0 0 16 8A7.77 7.77 0 0 0 8 .5m0 13.75A6.52 6.52 0 0 1 1.25 8A6.52 6.52 0 0 1 8 1.75A6.52 6.52 0 0 1 14.75 8A6.52 6.52 0 0 1 8 14.25"
      />
    </svg>
  );
}
